import { Logger } from "../../util/log/Logger";
import { Timer } from "../../util/time/Timer";
import { ViewUtils } from "../../util/view/ViewUtils";
import { FactoryManager } from "../factory/FactoryManager";
import { AbstractView } from "../view/AbstractView";
import { TitanSprite } from "./TitanSprite";
/**
 * Clock.ts
 */
export class Clock extends AbstractView {
    constructor(properties, portraitProperties) {
        super(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
        this.run();
    }
    create() {
        super.create();
        this.createBackground();
        this.createTimeField();
        this.createTimer();
        this.update();
        this.start();
        this.visible = this.isEnabled();
    }
    postCreate() {
        super.postCreate();
        Logger.addObjectRef(this, "Clock");
    }
    destroy() {
        super.destroy();
        if (this.timer) {
            this.timer.stop();
        }
        this.removeChild(this.timeField);
        this.timeField.destroy();
        this.uiProperties = null;
        this.landscapeProperties = null;
        this.portraitProperties = null;
        this.timeField = null;
        this.timer = null;
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    createBackground() {
        if (this.uiProperties.backgroundProperties) {
            this.background = new TitanSprite(this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
            this.background.name = "background";
            this.addChild(this.background);
        }
    }
    createTimeField() {
        this.timeField = ViewUtils.createField(this, this.landscapeProperties.timeFieldProperties, this.portraitProperties?.timeFieldProperties);
    }
    createTimer() {
        this.timer = new Timer(this.uiProperties.updateInterval);
        this.timer.onUpdate(this.handleTimerUpdate, this);
    }
    start() {
        this.timer.start();
    }
    stop() {
        this.timer.stop();
    }
    handleTimerUpdate() {
        this.update();
    }
    update() {
        this.timeField.setText(this.formatTime());
    }
    formatTime() {
        let formatted = "";
        let model = this.core.getModel();
        let timeData = model.getTime();
        if (timeData) {
            let time = timeData.update(this.uiProperties.updateInterval);
            for (let i = 0; i < time.length; i++) {
                if (time[i] < 10) {
                    time[i] = "0" + time[i];
                }
            }
            formatted = time.join(":") + " ";
        }
        return formatted;
    }
    isEnabled() {
        let enabled = true;
        let operatorConfig = FactoryManager.getInstance().getFactory().getOperatorConfig();
        if (typeof operatorConfig["isClockEnabled"] === "function") {
            enabled = operatorConfig.isClockEnabled();
        }
        return enabled;
    }
}
//# sourceMappingURL=Clock.js.map